import { useMemo } from "react";
import { enums } from "@shared/constants";
import type { BaseTicketBasketOnHoldDetailsSerializer } from "@app-contexts/user/features/basket/data/types/basket";

type UseHoldQuantityReturn = {
  /** `false` for basic holds, `true` for dynamic holds, `null` when no hold override applies */
  holdEnforcesQuantityChange: boolean | null;
  holdMinQuantity: number | null | undefined;
  holdMaxQuantity: number | null | undefined;
};

export function useHoldQuantity(
  onHoldDetail: BaseTicketBasketOnHoldDetailsSerializer | undefined
): UseHoldQuantityReturn {
  const holdType = onHoldDetail?.hold_type;

  const isDynamicHold = holdType === enums.BASKET_ON_HOLD_TYPE_MAP.DYNAMIC.id;
  const isBasicHold = holdType === enums.BASKET_ON_HOLD_TYPE_MAP.BASIC.id;

  const holdEnforcesQuantityChange = useMemo(() => {
    if (isBasicHold) return false;
    if (isDynamicHold) return true;
    return null;
  }, [isBasicHold, isDynamicHold]);

  const holdMinQuantity = isDynamicHold
    ? onHoldDetail?.purchase_limit_min
    : undefined;

  const holdMaxQuantity = isDynamicHold
    ? onHoldDetail?.purchase_limit_max
    : undefined;

  return { holdEnforcesQuantityChange, holdMinQuantity, holdMaxQuantity };
}
